const AtFaultStatusTypes = [
  // "Not Asked", //0
  'At Fault', //1
  'Not At Fault', //2
  //   "Unknown" // 3
];

export default AtFaultStatusTypes;
